/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_AnonymiseInputs */

const cs_gdpr_anonymise = /** @type {(inputs: Gdpr_AnonymiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anonymizovat`)
};

const en_gdpr_anonymise = /** @type {(inputs: Gdpr_AnonymiseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anonymise`)
};

/**
* | output |
* | --- |
* | "Anonymise" |
*
* @param {Gdpr_AnonymiseInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_anonymise = /** @type {((inputs?: Gdpr_AnonymiseInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_AnonymiseInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_anonymise(inputs)
	return cs_gdpr_anonymise(inputs)
});